import { Component } from '@angular/core';
@Component({
	selector: 'network-indicator',
	templateUrl: './network-indicator.component.html',
	styleUrls: ['./network-indicator.component.scss'],
	standalone: false
})
export class NetworkIndicatorComponent {

	constructor () {}
}
